import { NgModule, ModuleWithProviders } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CommonModule } from '@angular/common';
import {ScrollingModule} from '@angular/cdk/scrolling';

import { DndModule } from 'ngx-drag-drop';

import {FieldsModule} from '../fields/fields.module';
import { GettyModule } from '../getty/getty.module';
import {SharedModule} from '../shared/shared.module';

import {SlideshowService, TakeoverDialog, AutosaveDialog, SendToEditorDialog, 
    DeleteDialog, PublishDialog, PublishScheduleDialog, CopyDialog, 
    CannotViewDialog, SetStatusDialog, FeaturedImageDialog} from './slideshow.service';
import {SlideshowComponent, SitesPipe, GoBackDialog, CommentDialog, 
    DeleteMultipleDialog, DeleteMultipleErrorDialog, DeleteMultipleConfirmDialog} from './slideshow.component';

import {ImageDetailsComponent} from './images/image-details.component';
import {MediaDialog} from './images/media-dialog';
import {ImageListComponent} from './images/image-list';
import {CropperComponent} from './images/cropper.component';

import {EmbedContentComponent} from './slide/parts/embed.component';

import {ImageComponent, TempImagesPipe, MobileOnlyDialog} from './slide/parts/image.component';
import { CreateMultipleDialog, MlSlideDialog, MlSlideErrorDialog, SlideComponent } from './slide/slide.component';
import {SlidesComponent} from './slide/slides.component';

import {SlideNavBarComponent} from './slidenav/bar/slidenavbar.component';
import {SlideNavPanelComponent} from './slidenav/panel/slidenavpanel.component';
import { TeaserDialog } from './slidenav/slidenav.service';

import {WritingComponent} from './tabs/writing.component';
import {DetailsComponent} from './tabs/details.component';
import {PreviewComponent} from './tabs/preview.component';
import {PreviewArticleComponent} from './tabs/preview/article.component';
import {PreviewContentComponent} from './tabs/preview/content.component';
import {PreviewContentQuizComponent} from './tabs/preview/content-quiz.component';
import { PreviewEmbedComponent } from './tabs/preview/embed.component';
import {PreviewImageQuizComponent} from './tabs/preview/parts/image-quiz.component';
import {PreviewQuestionComponent} from './tabs/preview/parts/question.component';
import {PreviewQuizIntroComponent} from './tabs/preview/parts/intro-quiz.component';
import {PreviewResultsComponent} from './tabs/preview/parts/results.component';
import {MetaComponent, ImagesDialog} from './tabs/meta.component';
import { JoyrideModule } from '../joyride/joyride.module';
import { PreviewImageComponent } from './tabs/preview/parts/image.component';
import {PreviewImageDialog} from './images/preview-image-dialog';
import {AutosizeIframeDirective} from '../shared/autosize-iframe.directive';
import { AdsComponent } from './tabs/ads.component';
import { AdPlatformComponent } from './tabs/preview/parts/ad-platform.component';
import { MlPromptComponent } from '../ml-prompt/ml-prompt.component';
import { MlPromptFieldComponent } from '../ml-prompt/prompt-field/ml-prompt-field.component';
import { MlResultFieldComponent } from '../ml-prompt/result-field/ml-result-field.component';
import { MlAssignmentComponent } from '../ml-assignment/ml-assignment.component';
import { WarnAboutMlChangesDialog } from '../ml-assignment/dialog/warning/warn-about-ml-changes-dialog.component';
import { AssignmentPromptDialog } from '../ml-assignment/dialog/prompt/assignment-prompt-dialog.component';
import { GenerateStatusDialog } from '../ml-assignment/dialog/generate/generate-status-dialog.component';
import { StatusLineComponent } from '../ml-assignment/dialog/generate/status-line/status-line.component';

@NgModule({
    declarations: [ 
        SlideshowComponent,
        GoBackDialog,
        CommentDialog,
        CreateMultipleDialog,
        DeleteMultipleDialog,
        DeleteMultipleConfirmDialog,
        DeleteMultipleErrorDialog,
        MlSlideDialog,
        MlSlideErrorDialog,
        // images
        ImageDetailsComponent,
        CropperComponent,
        PreviewImageDialog,
        // parts
        EmbedContentComponent,
        ImageComponent,
        ImageListComponent,
        MediaDialog,
        MobileOnlyDialog,
        // slides
        SlideComponent,
        SlidesComponent,
        //navigation
        SlideNavBarComponent,
        SlideNavPanelComponent,
        TeaserDialog,
        //tabs
        DetailsComponent,
        PreviewComponent,
        PreviewArticleComponent,
        PreviewContentComponent,
        PreviewImageComponent,
        PreviewContentQuizComponent,
        PreviewEmbedComponent,
        PreviewImageQuizComponent,
        PreviewQuestionComponent,
        PreviewQuizIntroComponent,
        PreviewResultsComponent,
        MetaComponent,
        ImagesDialog,
        WritingComponent,
        SendToEditorDialog,
        //takeover
        TakeoverDialog,
        AutosaveDialog,
        DeleteDialog,
        PublishDialog,
        PublishScheduleDialog,
        CopyDialog,
        CannotViewDialog,
        SetStatusDialog,
        FeaturedImageDialog,
        //pipes
        SitesPipe,
        TempImagesPipe,
        //directives
        AutosizeIframeDirective,
        AdsComponent,
        AdPlatformComponent,
        MlPromptComponent,
        MlPromptFieldComponent,
        MlResultFieldComponent,
        MlAssignmentComponent,
        WarnAboutMlChangesDialog,
        AssignmentPromptDialog,
        GenerateStatusDialog,
        StatusLineComponent
    ],
    imports: [
        BrowserModule,
        CommonModule,
        ScrollingModule,
        FieldsModule,
        SharedModule,
        DndModule,
        GettyModule,
        JoyrideModule
    ],
    exports: [
        BrowserModule,
        CommonModule,
        SlideComponent,
        TempImagesPipe
    ]
})
export class SlideshowModule { 
    static forRoot(): ModuleWithProviders<SlideshowModule> {
        return {
            ngModule: SlideshowModule,
            providers: [SlideshowService]
        }
    }
}